"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TextArea = function (props) {
    return react_1.default.createElement("textarea", { className: (0, classnames_1.default)("formsCommon-TextArea", { "formsCommon-TextArea-long": props.isLong }), rows: props.rows, cols: props.cols, placeholder: props.placeholder, onChange: function (e) { return props.onChange(e.target.value); } });
};
exports.default = TextArea;
